import React from 'react';
import styled from 'styled-components';

export type TabValue = 'items' | 'orders';

type BuyItAgainTabsProps = {
  activeTab: TabValue;
  onTabChange: (tab: TabValue) => void;
};

export function BuyItAgainTabs({ activeTab, onTabChange }: BuyItAgainTabsProps): JSX.Element {
  return (
    <TabsContainer role='tablist' data-testid='buy-it-again-tabs' aria-label='Buy it again'>
      <PillButton
        role='tab'
        aria-selected={activeTab === 'orders'}
        aria-controls='orders-tab-panel'
        $active={activeTab === 'orders'}
        onClick={() => onTabChange('orders')}
        data-testid='orders-pill-tab'
      >
        Orders
      </PillButton>
      <PillButton
        role='tab'
        aria-selected={activeTab === 'items'}
        aria-controls='items-tab-panel'
        $active={activeTab === 'items'}
        onClick={() => onTabChange('items')}
        data-testid='items-pill-tab'
      >
        Items
      </PillButton>
    </TabsContainer>
  );
}

const TabsContainer = styled.div`
  display: flex;
  gap: 8px;
  padding: 0 20px;
`;

const PillButton = styled.button<{ $active: boolean }>`
  background: ${({ $active, theme }) => ($active ? theme.colors.grey[25] : theme.colors.blueGrey[90])};
  color: ${({ $active, theme }) => ($active ? theme.colors.white : theme.colors.grey[25])};
  border: none;
  border-radius: 100px;
  height: 36px;
  flex: 1;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
`;
